export default __webpack_public_path__ + "static/14_33-26cd75b5e7f0cce084296eab3727c4e9.png";